import {
  ParticipantTile,
  TrackReferenceOrPlaceholder,
} from "@livekit/components-react";
import classNames from "./MeetingParticipant.module.css";
import MeetingParticipantPlaceholder from "./MeetingParticipantPlaceholder";
import { useEffect, useMemo, useState } from "react";
import { useMeeting } from "../../../hooks/meeting";
import { getLanguageFlag } from "../../../types";
import { FiMic, FiMicOff } from "react-icons/fi";

export const ParticipantMetadata = (props: {
  language: string;
  name: string;
  timezone?: string;
  micEnabled: boolean;
}) => {
  const [time, setTime] = useState<string>();
  useEffect(() => {
    if (!props.timezone) {
      return;
    }

    const getTime = setInterval(() => {
      setTime(
        new Date().toLocaleString("en-US", {
          timeZone: props.timezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      );
    }, 1000 * 30);
    setTime(
      new Date().toLocaleString("en-US", {
        timeZone: props.timezone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    );

    return () => {
      clearInterval(getTime);
    };
  }, [props.timezone]);

  return (
    <>
      <div
        className={`${classNames.ParticipantTooltip} ${classNames.ParticipantName}`}
      >
        {getLanguageFlag(props.language)} {props.name}
      </div>
      {time && (
        <div
          className={`${classNames.ParticipantTooltip} ${classNames.ParticipantTime}`}
        >
          {time}
        </div>
      )}
      <div
        className={`${classNames.ParticipantTooltip} ${classNames.ParticipantMicEnabled}`}
      >
        {props.micEnabled ? (
          <FiMic />
        ) : (
          <FiMicOff color="var(--langfinity-red)" />
        )}
      </div>
    </>
  );
};

export default function MeetingParticipant(props: {
  trackRef: TrackReferenceOrPlaceholder;
  style?: React.CSSProperties;
}) {
  const metadata = useMemo(() => {
    const json = props.trackRef.participant.metadata;

    if (!json) {
      return undefined;
    }

    const parsed = JSON.parse(json) as {
      name: string;
      language: string;
      timezone?: string;
    };
    return parsed;
  }, [props.trackRef]);

  const [meeting] = useMeeting();
  if (
    props.trackRef.publication?.videoTrack &&
    !props.trackRef.publication.videoTrack.isMuted &&
    (!meeting.media.applyingBackground || !props.trackRef.participant.isLocal)
  ) {
    return (
      <div className={classNames.MeetingParticipant}>
        {metadata && (
          <ParticipantMetadata
            language={metadata.language}
            name={metadata.name}
            timezone={metadata.timezone}
            micEnabled={props.trackRef.participant.isMicrophoneEnabled}
          />
        )}
        <ParticipantTile trackRef={props.trackRef} style={props.style} />
      </div>
    );
  }
  return (
    <div className={classNames.MeetingParticipant}>
      {metadata && (
        <ParticipantMetadata
          language={metadata.language}
          name={metadata.name}
          timezone={metadata.timezone}
          micEnabled={props.trackRef.participant.isMicrophoneEnabled}
        />
      )}
      <MeetingParticipantPlaceholder
        name={metadata?.name}
        style={props.style}
      />
    </div>
  );
}
